import { BuildingOffice2Icon, BriefcaseIcon, GlobeAltIcon, MapPinIcon, UsersIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface InfoItem {
  icon: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & React.RefAttributes<SVGSVGElement>>;
  label: string;
  value: string;
}

export default function VillageInfo() {
  const { t } = useTranslation();

  const info: InfoItem[] = [
    {
      icon: UsersIcon,
      label: t('Population'),
      value: t('Village Info Population'),
    },
    {
      icon: GlobeAltIcon,
      label: t('Languages'),
      value: t('Village Info Languages'),
    },
    {
      icon: MapPinIcon,
      label: t('Postal Code'),
      value: t('Village Info Postal Code'),
    },
    {
      icon: BuildingOffice2Icon,
      label: t('Nearest City'),
      value: t('Village Info Nearest City'),
    },
    {
      icon: MapPinIcon,
      label: t('Nearest Railway Station'),
      value: t('Village Info Nearest Railway Station'),
    },
    {
      icon: BriefcaseIcon,
      label: t('Main Occupations'),
      value: t('Village Info Occupations'),
    },
  ];

  return (
    <section className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold mb-8 text-center text-primary-700">
          {t('Village Information')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {info.map((item) => (
            <div
              key={item.label}
              className="flex items-start gap-3 rounded-lg bg-gray-50 p-4 shadow"
            >
              <item.icon className="h-6 w-6 text-primary-600" />
              <div>
                <p className="text-sm font-medium text-gray-500">{item.label}</p>
                <p className="text-gray-900 font-semibold">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
